import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../../components/ui/accordion";
import PageMeta from "../../components/common/PageMeta";
import { NEWS } from "../../data/news";

function News() {
  return (
    <>
      <PageMeta
        title="お知らせ"
        description="ChatoraHack Lotteryのお知らせ一覧"
        path="/news"
        breadcrumbs={[
          { name: "TOP", path: "/" },
          { name: "お知らせ", path: "/news" },
        ]}
      />
      <section className="mx-auto w-auto min-h-screen mb-4">
        <div className="flex justify-between items-center mb-8 border-b border-b-2 border-primary-500 pb-2">
          <h1 className="text-2xl font-bold text-primary-500">お知らせ</h1>
        </div>
        <Accordion type="multiple" className="grid gap-4">
          {NEWS.slice().reverse().map((item, index) => (
            item.detail ? (
              <AccordionItem
                key={index}
                value={String(index)}
                className="border border-primary-500 rounded-lg bg-base-50"
              >
                <AccordionTrigger className="flex items-center px-4 py-4 gap-4 hover:no-underline [&>svg]:text-primary-500">
                  <span className="text-xs text-primary-500 shrink-0">{item.date}</span>
                  <span className="text-sm font-bold text-primary-500 text-left mr-auto">{item.title}</span>
                </AccordionTrigger>
                <AccordionContent className="px-4 pb-4">
                  <div
                    className="text-sm text-primary-500 [&_a]:underline [&_a:hover]:opacity-70"
                    dangerouslySetInnerHTML={{ __html: item.detail }}
                  />
                </AccordionContent>
              </AccordionItem>
            ) : (
              <div key={index} className="border border-primary-500 rounded-lg bg-base-50 px-4 py-4 flex items-center gap-4">
                <span className="text-xs text-primary-500 shrink-0">{item.date}</span>
                <span className="text-sm font-bold text-primary-500">{item.title}</span>
              </div>
            )
          ))}
        </Accordion>
      </section>
    </>
  );
}
export default News;